import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { ArrowUpCircle, ArrowDownCircle, TrashFill } from 'react-bootstrap-icons';
import './SectionControls.css';

const SectionControls = ({ 
  onMoveUp, 
  onMoveDown, 
  onDelete, 
  isFirstSection, 
  isLastSection 
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDelete = () => {
    setShowDeleteModal(false);
    onDelete();
  };

  return (
    <div className="section-controls">
      <Button 
        variant="outline-secondary" 
        size="sm" 
        onClick={onMoveUp}
        disabled={isFirstSection}
        title="Move section up"
      >
        <ArrowUpCircle />
      </Button>
      <Button 
        variant="outline-secondary" 
        size="sm" 
        onClick={onMoveDown}
        disabled={isLastSection}
        title="Move section down"
      >
        <ArrowDownCircle />
      </Button>
      <Button 
        variant="outline-danger" 
        size="sm" 
        onClick={() => setShowDeleteModal(true)}
        title="Delete section"
      >
        <TrashFill />
      </Button>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this section? This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SectionControls;
